export type IntegrationType = 'rubyplay' | 'relax' | 'pop' | 'ucip' | 'lnw' | 'betmgm';
